import { createFileRoute, redirect } from '@tanstack/react-router'
import { insureSearchSchema } from '../../../src/schemas/routeSchemas'

export const Route = createFileRoute('/insure/')({
  validateSearch: (search) => insureSearchSchema.parse(search),
  loaderDeps: () => ({}),
  beforeLoad: () => {
    throw redirect({ to: '/insure/recommend' })
  },
})
